import { Text, Box } from '@cad-arc';

export function MenuLoadingError(): React.ReactElement {
    return (
        <Box padding="0 10px 0 10px">
            <Text>Could not load the menu</Text>
        </Box>
    );
}
